<template>
  <div class="main-body">
    <div class="header">待审批实践站点</div>
    <div class="out">


      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column prop="name" label="实践站点名称"  fixed></el-table-column>

        <el-table-column prop="loginName" label="登陆账号" ></el-table-column>
        <el-table-column prop="phone" label="手机号" ></el-table-column>
        <el-table-column prop="address" label="地址" ></el-table-column>

        <el-table-column prop="applyTime" label="申请时间" :formatter="getCreateTime" ></el-table-column>

        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
<!--            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
            <el-button size="mini" @click="handleOK(scope.$index, scope.row)">通过</el-button>
            <el-button size="mini" type="danger" @click="handleDel(scope.$index, scope.row)">驳回</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Deal ref="myDeal" v-show="showModalDeal" v-on:closeEdit="closeDeal" v-on:getList="getList"></Deal>

  </div>
</template>

<script>

import Deal from "./Deal";

import {timefilters, timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",
  data(){
    return{

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,



      typeValue:[],
      type:'',


      showModalDeal:false,

      th:0,

    }
  },
  created(){
    this.getList();
    this.th = this.$store.state.tableHeight+50;
  },
  components:{
    Deal
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val+50;
    },
  },
  methods:{


    getCreateTime(row) {
      return timefilters(row.applyTime);
    },

    closeEdit:function(){
      this.showModalDeal = !this.showModalDeal;
    },

    search(){
      this.currentPage = 1;
      this.getList();
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'PracticeSite/PageApply',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    handleEdit(index, row) {
      this.$refs.myDeal.init(row);
      this.showModalDeal = !this.showModalDeal;
    },

    handleOK(index, row) {

      this.$confirm('确定审核通过吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.pass(row.practiceSiteCode);

      }).catch(e=>e)

    },
    handleDel(index, row) {
      this.$confirm('确定审核驳回吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.rejectDel(row.practiceSiteCode);

      }).catch(e=>e)
    },


    pass(practiceSiteCode){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'PracticeSite/Pass',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          practiceSiteCode:practiceSiteCode,
          applyStatus:2,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){

          this.getList();

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    rejectDel(practiceSiteCode){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'PracticeSite/RejectDel',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          practiceSiteCode:practiceSiteCode,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){

          this.getList();

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>

<style scoped>

</style>
